import {  WpObjectPromise, WpFilters } from "src/app/service/global.service";
import { AbstractController } from "./abstract-controller";

export class BrowserAttestationController extends AbstractController{
  
  private readonly service:string="api/v1.0/browser-attestations";

  public async search(filters:WpFilters): Promise<WpObjectPromise>{
    return await this.network.post(`${this.service}/search`, filters, "wpApiUrl");
  }
}